import { useRef } from 'react';
import { useLocation } from 'react-router';
import core, { App } from '@gin-betting/core';
import { omit } from 'lodash';

const {
    services: { parse, stringify },
    hooks: { useDidUpdate },
} = core;

const RESOLVE_LIST_REQUEST_TIME = 50;

const FILTER_LOCATION_SEARCH: Array<keyof App.SearchObj> = ['page'];

const useScrollToTop = (): void => {
    const timerIdRef = useRef<number | undefined>();
    const { pathname, search } = useLocation();
    const formattedSearch = stringify(
        omit(parse(search), FILTER_LOCATION_SEARCH)
    );

    useDidUpdate(() => {
        timerIdRef.current = window.setTimeout(() => {
            window.scrollTo(0, 0);
        }, RESOLVE_LIST_REQUEST_TIME);

        return () => {
            clearTimeout(timerIdRef.current);
        };
    }, [pathname, formattedSearch]);
};

export default useScrollToTop;
